import { AxiosResponse } from "axios";
import { PaginationResponse } from "../models/common/paginationResponse";
import { api } from "./base";
import { DeleteValuatorBodyshopRequest, supervisionAssignmentFilterRequest, SupervisionAssignmentPaginedRequest, supervisionAssignmentRequest } from "../models/request/supervisionAssignment";
import { Result } from "../models/common/resultResponse";
import { supervisionAssignmentFilterResponse, SupervisorAssignmentResponse } from "../models/response/supervisionAssignmentResponse";

const baseRoute: string = 'Valuator_Bodyshop';

export class SupervisionAssignmentApi{
    
    getBodyShopByCompany(request: SupervisionAssignmentPaginedRequest)
    : Promise<AxiosResponse<PaginationResponse<SupervisorAssignmentResponse>>>{
        return api.get(`Valuator_Bodyshop/getallbodyshopbyvaluator`, {params: request});
    }

    deleteSupervisionAssingment(request: DeleteValuatorBodyshopRequest) 
    : Promise<AxiosResponse>{
        return api.delete(`${baseRoute}/delete`, { data: request });
    }

    saveActAsSupervisor(request: supervisionAssignmentRequest)
    : Promise<AxiosResponse<Result<SupervisorAssignmentResponse>>> {
        return api.post(`Valuator_Bodyshop/saveactassupervisor`, request);
    }

    getbodyshopinsurerbyfilter(request: supervisionAssignmentFilterRequest | null) 
    : Promise<AxiosResponse<Result<supervisionAssignmentFilterResponse>>>{
        return api.get(`${baseRoute}/getbodyshopinsurerbyfilter`, {params: request});
    }

    saveSupervisorAssignments(request: supervisionAssignmentRequest)
    : Promise<AxiosResponse>{
        return api.post(`${baseRoute}/savesupervisorassignments`, request)
    }
}

export const supervisionAssignmentApi = new SupervisionAssignmentApi();